import React, { useEffect, useState } from "react";
import styles from "./cartPopUp.module.css";
import { ReactComponent as Battery0 } from "../../assets/icons/battery/0.svg";
import { ReactComponent as Battery15 } from "../../assets/icons/battery/15.svg";
import { ReactComponent as Battery30 } from "../../assets/icons/battery/30.svg";
import { ReactComponent as Battery50 } from "../../assets/icons/battery/50.svg";
import { ReactComponent as Battery75 } from "../../assets/icons/battery/75.svg";
import { ReactComponent as Battery90 } from "../../assets/icons/battery/90.svg";
import { ReactComponent as CartOnline } from "../../assets/icons/cartIcons/cart_online.svg";
import { ReactComponent as CartOffline } from "../../assets/icons/cartIcons/cart_offline.svg";
import { ReactComponent as CallBtn } from "../../assets/icons/general/callBtn.svg";
import { ReactComponent as MicIcon } from "../../assets/icons/general/microphone.svg";
import { ReactComponent as Camera } from "../../assets/icons/general/rtsp-camera.svg";
import { ReactComponent as RtspCameraPlus } from "../../assets/icons/general/rtsp-camera-plus.svg";

import BreakOp from "../../assets/icons/general/break_op.js";
import CircularBattery from "../battery/circularBattery";
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import ShuttleMissionDialog from '../missions/shuttle/ShuttleMissionDialog';
import { Modal, Box, Tooltip, IconButton } from "@mui/material";
import CloseActiveMission from "../../services/closeActiveMission";
import useAuth from "../../hooks/Auth/useAuth";
import common_types from "../../common_files/common_types";
import AddTaskIcon from "@mui/icons-material/AddTask";
import SendTaskAction from "../../services/completeTask";
import Swal from "sweetalert2";
//import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";

import CloseIcon from "@mui/icons-material/Close";
import { operatorBreakFunction } from "../../utils/operatorBreakFunction";
import CartCameraModal from "../modals/CartCameraModal.js";
import CartAudioRecorderModal from "../modals/CartAudioRecorderModal.js";
import useRTSPContext from "../../redux/context/RTSPProvider.js";
import CartRtspViewer from "../cartCameras/cartRtspViewer/CartRtspViewer.js";
import OperatorTreatmentResponseEvent from "../../services/operatorTreatmentResponseEvent";
import renderCustomModalFunction from "../customModal/modalWrapper/renderCustomModalFunction";
import PausePlayCommand from "../PausePlayCommand.jsx";
import SaveCartRecord from "../SaveCartRecord/SaveCartRecord.jsx";
import ReverseCartIcon from "../ReverseCart/ReverseCartIcon.jsx";

const CHARGING = common_types.mission_type_enum.MISSION_TYPE_CHARGING;
const SHUTTLE = common_types.mission_type_enum.MISSION_TYPE_SHUTTLE;
const NONE = common_types.mission_type_enum.MISSION_TYPE_NONE;
const TRANSPORTATION =
  common_types.mission_type_enum.MISSION_TYPE_TRANSPORTATION;

const colorAccordingState = {};
colorAccordingState[CHARGING] = "#FFD02C";
colorAccordingState[SHUTTLE] = "#FF8127";
colorAccordingState[NONE] = "#616E87";
colorAccordingState[TRANSPORTATION] = "#FF5368";

const headerTextAccordingState = {};
headerTextAccordingState[CHARGING] = "CHARGING";
headerTextAccordingState[SHUTTLE] = "SHUTTLE";
headerTextAccordingState[NONE] = "NONE";
headerTextAccordingState[TRANSPORTATION] = "TRANSPORTATION";

function CartPopUp({
  cartInfo,
  offline,
  addCartTOHighPatsh,
  cartToShowPath,
  cartsPaths,
  selectedCart,
  setSelectedCart,
  mobileSheet,
  setStaticPopup,
  onLockPopupKey,
  onReleasePopupKey,
  onStartReverse,
}) {
  const cartNumber = cartInfo?.cart_number ?? cartInfo?.cart_id ?? null;
  const cartName =
    cartInfo?.cartData?.cart_name ??
    cartInfo?.cart_name ??
    "";

  const chargeRaw = Number(cartInfo?.charge);
  const chargePct = Number.isFinite(chargeRaw)
    ? Math.max(0, Math.min(100, chargeRaw))
    : null;

  const versionText = cartInfo?.sw_version || "N/A";
  const [openRtsp, setOpenRtsp] = React.useState(false);
  const [openCameras, setOpenCameras] = React.useState(false);
    const [openShuttleDialog, setOpenShuttleDialog] = React.useState(false);
  let { relevantUrl, sitesSockectsConnection, relevantSite, isPhoneSize, sitesEventsMap } = useAuth();

  const popupLockActiveRef = React.useRef(false);

  React.useEffect(() => {
    if (!openShuttleDialog) {
      if (popupLockActiveRef.current) {
        if (typeof onReleasePopupKey === 'function') {
          onReleasePopupKey();
        }
        popupLockActiveRef.current = false;
      }
      return;
    }
    if (!popupLockActiveRef.current && typeof onLockPopupKey === 'function') {
      onLockPopupKey();
      popupLockActiveRef.current = true;
    }
  }, [openShuttleDialog, onLockPopupKey, onReleasePopupKey]);

  React.useEffect(() => {
    return () => {
      if (popupLockActiveRef.current) {
        if (typeof onReleasePopupKey === 'function') {
          onReleasePopupKey();
        }
        popupLockActiveRef.current = false;
      }
    };
  }, [onReleasePopupKey]);

  const [openRecorder, setOpenRecorder] = useState(false);
  const openRecorderModal = () => setOpenRecorder(true);
  const closeRecorderModal = () => setOpenRecorder(false);

  const openCamerasFunction = () => setOpenCameras(true);
  const closeCamerasFunction = () => setOpenCameras(false);

  const openRtspFunction = () => setOpenRtsp(true);
  const closeRtspFunction = () => setOpenRtsp(false);
  const { cameraMap } = useRTSPContext();

  const hasRtsp = (() => {
    const cams = cameraMap?.[relevantSite]?.[cartNumber];
    return !!(cams && Object.keys(cams).length > 0);
  })();

  // Determine operator treatment active state from socket events (fallback to cartInfo list)
  const siteEvents = Array.isArray(sitesEventsMap?.[relevantSite]) ? sitesEventsMap[relevantSite] : [];
  const operatorEvent = siteEvents.find(
    (ev) =>
      ev?.event_type === common_types.event_type_enum.TYPE_OPERATOR_TREATMENT &&
      Number(ev?.cart_id) === Number(cartNumber)
  );
  const operatorActiveFromEvents = !!operatorEvent;
  const operatorActiveFromCart = Array.isArray(cartInfo?.operatorTreatmentList) && cartInfo.operatorTreatmentList.length > 0;
  const operatorTreatmentActive = operatorActiveFromEvents || operatorActiveFromCart;

  const callToActiveUser = () => {
    const userId = cartsPaths?.[cartNumber]?.mission?.userId;
    if (sitesSockectsConnection && relevantSite && userId) {
      const relevant_socket = sitesSockectsConnection[relevantSite];
      if (relevant_socket) {
        relevant_socket.emit("getUserDetails", userId);
      } else {
        console.log("No relevant socket found for the site");
      }
    } else {
      console.log("Missing data to make the call");
    }
  };

  const completeTask = async (p_mission_id, p_taskId) => {
    const sendCartAction = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
    });
    if (sendCartAction.isConfirmed) {
      const taskAction = "TASK_ACTION_COMPLETED";
      const completeTaskResponse = await SendTaskAction(
        relevantUrl,
        p_mission_id,
        p_taskId,
        taskAction,
        taskAction
      );
      if (completeTaskResponse !== "ok") {
        console.log("completeTaskResponse", completeTaskResponse);
      }
    }
  };

  useEffect(() => {
    if (
      Array.isArray(cartToShowPath) &&
      cartToShowPath.includes(cartNumber)
    ) {
      if (cartsPaths && !cartsPaths[cartNumber]) {
        let arr = cartToShowPath.filter(function (item) {
          return item !== cartNumber;
        });
        addCartTOHighPatsh(arr);
      }
    }
  }, [cartToShowPath, cartsPaths, addCartTOHighPatsh, cartNumber]);

  // When the cart disconnects, upstream state can briefly make `cartInfo` (or nested fields) null/partial.
  // Returning null here prevents hard crashes during that render window.
  if (cartNumber == null) return null;

  if (offline) {
    return (
        <div className={mobileSheet ? styles.mobile_sheet_wrapper : styles.body_offline_container}>
          {/* Close button for desktop mode - offline */}
          {!mobileSheet && setStaticPopup && (
            <IconButton
              onClick={() => setStaticPopup({ position: null, cartInfo: null })}
              sx={{
                position: "absolute",
                top: 4,
                right: 4,
                zIndex: 2,
                color: "white",
                backgroundColor: "rgba(0,0,0,0.25)",
                width: 22,
                height: 22,
                padding: 0,
                minWidth: 0,
                lineHeight: 1,
                borderRadius: '4px',
                '& svg': { fontSize: 14 },
                '&:hover': {
                  backgroundColor: 'rgba(0,0,0,0.45)'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
          
          {/* Offline variant remains mostly the same */}
          <div
            className={styles.header_container}
            style={{
              backgroundColor: "#FF5368",
            }}
          >
            <div>OFFLINE</div>
          </div>

          <div className={styles.status_bar}>
            <span className={styles.cartName}>
              {String(cartInfo?.cart_id ?? cartNumber)},
              <span className={styles.cart_name_text}>{cartName}</span>
              <span className={styles.cart_version_text}>Version: {"N/A"}</span>
            </span>
            <div className={styles.battery}>
              {<CartOffline />}
              <span>{"offline"}</span>
            </div>
          </div>
        </div>
    );
  } else {
    // Derive availability and mission type from live mission state
    const __cartNumber = cartInfo?.cart_number;
    const __missionObj = cartsPaths?.[__cartNumber]?.mission;
    const effectiveAvailable = __missionObj ? false : !!cartInfo?.available;
    const effectiveMissionType = __missionObj
      ? (cartInfo?.mission_type && cartInfo.mission_type !== NONE ? cartInfo.mission_type : SHUTTLE)
      : cartInfo?.mission_type;

    return (
        <div className={mobileSheet ? styles.mobile_sheet_wrapper : styles.body_container}>
          {/* Close button for desktop mode */}
          {!mobileSheet && setStaticPopup && (
            <IconButton
              onClick={() => setStaticPopup({ position: null, cartInfo: null })}
              sx={{
                position: 'absolute',
                top: 5,
                right: 5,
                zIndex: 9999,
                color: 'white',
                backgroundColor: 'rgba(0,0,0,0.25)',
                width: 22,
                height: 22,
                padding: 0,
                minWidth: 0,
                lineHeight: 1,
                borderRadius: '4px',
                boxShadow: '0 0 2px rgba(0,0,0,0.4)',
                '& svg': { fontSize: 14 },
                '&:hover': { backgroundColor: 'rgba(0,0,0,0.45)' }
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
          
          {/* Removed internal mobile drag handle to avoid duplicate with slider handle */}
          {mobileSheet && (
            <div className={styles.mobile_close_btn_holder} onClick={(e)=>{e.stopPropagation();}}>
              {/* No internal close button */}
            </div>
          )}
          <div
            className={`${styles.header_container} ${mobileSheet ? styles.mobile_header : ""}`}
            style={{
              backgroundColor: effectiveAvailable
                ? "var(--dark_green)"
                : (colorAccordingState[effectiveMissionType] || colorAccordingState[NONE]),
            }}
          >
            <div>
              {effectiveAvailable
                ? "AVAILABLE"
                : (headerTextAccordingState[effectiveMissionType] || headerTextAccordingState[NONE])}
            </div>
          </div>
          <div className={`${styles.status_bar} ${mobileSheet ? styles.mobile_status_bar : ""}`}>
            <span className={styles.cartName}>
              {String(cartNumber)},
              <span className={styles.cart_name_text}>
                {cartName}
              </span>
              <span className={styles.cart_version_text}>Version: {versionText}</span>
            </span>

            <div className={styles.battery}>
              {cartInfo.online ? <CartOnline /> : <CartOffline />}
              <span>{cartInfo.online ? "online" : "offline"}</span>
              {chargePct != null && chargePct >= 90 ? (
                <Battery90 />
              ) : chargePct != null && chargePct >= 75 ? (
                <Battery75 />
              ) : chargePct != null && chargePct >= 50 ? (
                <Battery50 />
              ) : chargePct != null && chargePct >= 30 ? (
                <Battery30 />
              ) : chargePct != null && chargePct >= 15 ? (
                <Battery15 />
              ) : (
                <Battery0 />
              )}
              <span style={{ marginBottom: "-3px" }}>
                {chargePct != null ? `${Math.round(chargePct)}%` : "N/A"}
              </span>
            </div>
          </div>
          <div className={`${styles.actions_container} ${mobileSheet ? styles.mobile_actions : ""}`}>
            {/* Condensed icon row for mobile */}
          {cartsPaths &&
            cartsPaths[cartNumber] &&
            cartsPaths[cartNumber].mission &&
            <Tooltip title={cartsPaths[cartNumber].mission.path_status === 'DRIVING' ? 'Pause Moving Cart' : 'Play Moving Cart'} placement="bottom">
              <span
                className="pause-play-command"
                style={{
                  cursor: "pointer",
                  marginRight: "20%",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "3px 10px",
                  borderRadius: "4px",
                  backgroundColor: "#f5f7ff", // soft bluish background
                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)",
                  transition: "all 0.2s ease-in-out",
                }}
                onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#e0e7ff")}
                onMouseLeave={e => (e.currentTarget.style.backgroundColor = "#f5f7ff")}
              >
                <PausePlayCommand cartNumber={cartNumber} />
              </span>


            </Tooltip>
          }
            <Tooltip title="Open Cameras" placement="bottom">
              <span style={{ cursor: "pointer", margin: 4 }} onClick={openCamerasFunction}>
                <Camera style={{ cursor: "pointer" }} />
              </span>
            </Tooltip>
            {hasRtsp && (
              <Tooltip title="RTSP Live" placement="bottom">
                <span
                  style={{ cursor: "pointer", margin: 4 }}
                  onClick={openRtspFunction}
                >
                  <RtspCameraPlus />
                </span>
              </Tooltip>
            )}
            {!cartInfo.mission_id && !cartsPaths?.[cartNumber]?.mission && (
              <Tooltip title="Assign Shuttle" placement="bottom">
                <span style={{ cursor: 'pointer', margin:4 }} onClick={()=> {
                  if (isPhoneSize) {
                    // open via siteOverview mobile slider
                    window.dispatchEvent(new CustomEvent('openShuttleAssignSlider', { detail: {
                      cartInfo,
                      relevantUrl
                    }}));
                  } else {
                    setOpenShuttleDialog(true);
                  }
                }}>
                  <DirectionsBusIcon fontSize='small' />
                </span>
              </Tooltip>
            )}
            {/* Here is icons that are displayed always. */}
            <Tooltip title="Record Audio" placement="bottom">
              <span style={{ cursor: "pointer", margin: 4 }} onClick={openRecorderModal}>
                <MicIcon />
              </span>
            </Tooltip>


            {cartsPaths &&
              cartsPaths[cartNumber] &&
              cartsPaths[cartNumber].mission &&
              (effectiveMissionType !== SHUTTLE) && (
                <Tooltip title="Call Active User" placement="bottom">
                  <span style={{ cursor: "pointer", margin: 4 }} onClick={callToActiveUser}>
                    <CallBtn
                      style={{
                        display: "grid",
                        fontSize: "24px",
                        cursor: "pointer",
                      }}
                    />
                  </span>
                </Tooltip>
              )}
            {(Array.isArray(cartInfo.operatorTreatmentList) || operatorTreatmentActive) && (
                <Tooltip
                  title={
                    operatorTreatmentActive
                      ? "Disable Operator Treatment"
                      : "Enable Operator Treatment"
                  }
                  placement="bottom"
                >
                  <span
                    style={{ cursor: "pointer", margin: 4 }}
                    onClick={() => {
                      const cartId = cartNumber;
                      const online = cartInfo.online;
                      if (!operatorTreatmentActive) {
                        // Activate operator treatment using legacy endpoint
                        const activate = true;
                        operatorBreakFunction(relevantUrl, cartId, activate, online);
                      } else {
                        // Deactivate by resolving via the same service used in DraggableCartPanel
                        if (!online) {
                          Swal.fire({
                            icon: 'warning',
                            title: 'Cart must be online !',
                            position: 'center',
                            confirmButtonColor: '#00A7EE',
                          });
                          return;
                        }

                        // Confirm release of operator break using the same custom modal style
                        const headerText = `Operator Break. Cart id: ${cartId}`;
                        const bodyText = `Cart will  <span style="color:var(--dark_green);">cancel operator break</span>, are you sure ?`;
                        renderCustomModalFunction({
                          title: headerText,
                          bodyText: bodyText,
                          buttons: [
                            {
                              text: "Cancel",
                              class: "cancelButton",
                              closeModal: true,
                              value: "cancel",
                            },
                            {
                              text: "Confirm",
                              class: "dangerButton",
                              closeModal: true,
                              value: "confirm",
                              callback: () => {
                                const eventType = operatorEvent?.event_type || common_types.event_type_enum.TYPE_OPERATOR_TREATMENT;
                                const eventSubtype = operatorEvent?.subtype || common_types.TYPE_OPERATOR_TREATMENT.TEMPORARY_EVENT;
                                const eventName = operatorEvent?.name || 'Operator Treatment';
                                const OP = common_types.operation_cart_event_list.OPERATION_RESOLVED;

                                OperatorTreatmentResponseEvent(
                                  cartId,
                                  eventType,
                                  eventSubtype,
                                  eventName,
                                  OP,
                                  "",
                                  relevantUrl
                                ).then((response) => {
                                  if (response === 'ok') {
                                    Swal.fire({
                                      icon: 'success',
                                      title: `Operation ${OP} succeeded!`,
                                      position: 'center',
                                      confirmButtonColor: '#00A7EE',
                                    });
                                  } else {
                                    Swal.fire({
                                      icon: 'error',
                                      title: `Operation ${OP} failed: ${response}`,
                                      position: 'center',
                                      confirmButtonColor: '#00A7EE',
                                    });
                                  }
                                }).catch((error) => {
                                  Swal.fire({
                                    icon: 'error',
                                    title: `An error occurred during ${OP}!`,
                                    text: error?.message || String(error),
                                    position: 'center',
                                    confirmButtonColor: '#00A7EE',
                                  });
                                });
                              }
                            }
                          ],
                        });
                      }
                    }}
                  >
                    <BreakOp
                      fillColor={operatorTreatmentActive ? "var(--light_red)" : "#070A0E"}
                      style={{ fontSize: "22px", cursor: "pointer" }}
                    />
                  </span>
                </Tooltip>
              )}
              {/* Save Cart Record */}
          <Tooltip title="Save Cart Record" placement="bottom">
            <SaveCartRecord cartNumber={cartNumber} relevantUrl={relevantUrl} />
          </Tooltip>

          {/* Reverse Cart Icon */}
          {cartsPaths &&
            cartsPaths[cartNumber] &&
            cartsPaths[cartNumber].mission &&
            <Tooltip title="Reverse cart" placement="bottom">
              <ReverseCartIcon
                cartNumber={cartNumber}
                onStartReverse={onStartReverse}
              />
            </Tooltip>
          }
          </div>
          <div className={`${styles.mission_container} ${mobileSheet ? styles.mobile_scroll_area : ""}`}>
            {/* CHARGING */}
            <div>
              {cartInfo.mission_type === CHARGING ? (
                <div className={styles.circularBattery}>
                  <CircularBattery percent={chargePct ?? 0} />
                  <span className={styles.circularBatteryText}>
                    Fully charging by
                  </span>
                </div>
              ) : null}
            </div>
            {/* Transportation + Shuttle */}
            {cartsPaths &&
              cartsPaths[cartNumber] &&
              cartsPaths[cartNumber].mission ? (
              <div className={styles.mission}>
                <div className={styles.mission_user}>
                  {cartsPaths[cartNumber].mission.user_name}
                </div>
                <div className={styles.mission_dest}>
                  Destination: {cartsPaths[cartNumber].mission.dest_name}
                </div>
                <div className={styles.mission_dest}>
          {cartsPaths[cartNumber].mission.arrivalTime !=
                    null ? (
                    <>
                      Arrival:
                      {cartsPaths[cartNumber].mission.arrivalTime}
                    </>
                  ) : null}
                  <div
                    onClick={async () => {
                      const missionType = effectiveMissionType || cartInfo.mission_type;
                      let missionId = cartsPaths[cartNumber].mission.missionId;
                      CloseActiveMission(relevantUrl, missionId, missionType);
                    }}
                    className={styles.endRideBtn}
                  ></div>
                  
                </div>
                {Array.isArray(
                  cartsPaths[cartNumber].mission.active_tasks_list
                ) &&
                  cartsPaths[cartNumber].mission.active_tasks_list
                    .length > 0 && (
                    <>
                      <div
                        className={styles.mission_dest}
                        style={{ color: "#0DD02C", fontWeight: "600" }}
                      >
                        Active Tasks:
                      </div>
                      {cartsPaths[
                        cartNumber
                      ].mission.active_tasks_list.map((task, index) => (
                        <div
                          key={`active-task-${task.id}`}
                          className={styles.active_tasks}
                        >
                          <span
                            className={styles.mission_dest}
                            style={{ color: "#070A0E", fontWeight: "600" }}
                          >
                            {task.task_type}:
                          </span>
                          <span>
                            {typeof task.status_data === "object" ? (
                              Object.keys(task.status_data).map(
                                (innerKey, index) => (
                                  <span
                                    className={styles.active_tasks_text}
                                    key={`active-task-inner-status-${index}`}
                                  >
                                    <span
                                      style={{
                                        marginRight: "8px",
                                        fontWeight: "500",
                                      }}
                                    >
                                      {innerKey} :
                                    </span>
                                    <span style={{ maxWidth: "120px" }}>
                                      {task.status_data[innerKey]}
                                    </span>
                                  </span>
                                )
                              )
                            ) : (
                              <span>{task.status_data}</span>
                            )}
                          </span>
                          <span>
                            {(task.task_type ===
                              common_types.task_type.TRIGGERED_TASK_WAIT ||
                              task.task_type ===
                              common_types.task_type.TRIGGERED_TASK_SMS) && (
                                <button
                                  className={styles.complete_task_btn}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const missioId =
                                      cartsPaths[cartNumber].mission
                                        .missionId;
                                    completeTask(missioId, task.id);
                                  }}
                                >
                                  <AddTaskIcon
                                    sx={{
                                      height: "14px",
                                      width: "14px",
                                      marginRight: "4px",
                                    }}
                                  />{" "}
                                  Complete task
                                </button>
                              )}
                          </span>
                        </div>
                      ))}
                    </>
                  )}
              </div>
            ) : null}
          </div>
          <div className={`${styles.buttons} ${mobileSheet ? styles.mobile_buttons : ""}`}>
            <div
              className={`${styles.customChip} ${selectedCart === cartNumber
                  ? styles.focused_customChip
                  : styles.unfocused_customChip
                }`}
              onClick={() =>
                setSelectedCart(
                  selectedCart === cartNumber
                    ? null
                    : cartNumber
                )
              }
            >
              {selectedCart === cartNumber
                ? "Unfocus Cart"
                : "Focus on Cart"}
            </div>

            {cartsPaths && cartsPaths[cartNumber] ? (
              <div
                className={`${styles.customChip} ${cartToShowPath.includes(cartNumber)
                    ? styles.focused_customChip
                    : styles.unfocused_customChip
                  }`}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (cartToShowPath.includes(cartNumber)) {
                    let arr = cartToShowPath.filter(function (item) {
                      return item !== cartNumber;
                    });
                    addCartTOHighPatsh(arr);
                  } else {
                    addCartTOHighPatsh([
                      ...cartToShowPath,
                      cartNumber,
                    ]);
                  }
                }}
              >
                {cartToShowPath.includes(cartNumber)
                  ? "Disable Path"
                  : "Highlight Path"}
              </div>
            ) : null}
          </div>
          {/* Modals */}
          <CartAudioRecorderModal
            open={openRecorder}
            onClose={closeRecorderModal}
            baseUrl={relevantUrl}
            cartNumber={cartNumber}
          />
          <Modal
            open={openRtsp}
            onClose={closeRtspFunction}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: "80vw",
                maxWidth: "90vw",
                height: "80vh",
                maxHeight: "90vh",
                bgcolor: "background.paper",
                borderRadius: 2,
                p: 1,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              <IconButton
                onClick={closeRtspFunction}
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  zIndex: 2,
                  color: "var(--grey)",
                }}
                size="large">
                <CloseIcon />
              </IconButton>

              <CartRtspViewer
                cartId={cartNumber}
                site={relevantSite}
                isPhoneSize={isPhoneSize}
              />
            </Box>
          </Modal>
          <CartCameraModal
            open={openCameras}
            onClose={closeCamerasFunction}
            cartId={cartNumber}
            isPhoneSize={isPhoneSize}
          />
          {!isPhoneSize && (
            <ShuttleMissionDialog
              open={openShuttleDialog}
              onClose={()=> setOpenShuttleDialog(false)}
              relevantUrl={relevantUrl}
              cartInfo={cartInfo}
              categoriesArray={[]}
              categoriesIcons={{}}
              boundaries={null}
              roads={null}
              nonStopArea={null}
            />
          )}
        </div>
    );
  }
}
export default CartPopUp;

